/*
 * simple-tabs отличается от tabs тем, что он не стилизован.
 * На контейнер с ссылками добавляется класс js-simple-tabs.
 * Ссылки внутри этого контейнера имеют значение href в виде селектора на id элемента, которому надо добавить класс
 * active, при этом его соседним элементам этот класс удаляется.
 * Табу, который должен быть показан по умолчанию должен быть присвоен класс "active".
 */

$(document).on('click', '.js-simple-tabs a', function onClick(evt) {
    evt.preventDefault();

    $(this.hash)
        .addClass('active')
        .removeClass('hidden-accessible')
        .siblings()
        .removeClass('active')
        .addClass('hidden-accessible');

    // reinit slider
    $('.js-tabs-content .active')
        .find('.slick-initialized')
        .each(refreshSlider);

    // init popup gallery
    if ($('.js-tabs-content .active .popup-gallery').length) {
        initPopupGallery();
    }
});

$(init);

NLMK.initSimpleTabs = init;

function init() {
    $('.js-simple-tabs')
        .find('a')
        .each(eachTabTriggerAnchor);
}

function eachTabTriggerAnchor(anchorIndex, Anchor) {
    const $target = $(Anchor.hash);

    $target.toggleClass('hidden-accessible', !$target.hasClass('active'));
}

function refreshSlider() {
    $(this).slick('refresh');
}

function initPopupGallery() {
    NLMK.initPopupGallery();
}



// WEBPACK FOOTER //
// ./js/main/module/simple-tabs.js